import { Routes } from '@angular/router';
import { AuthenticationComponent } from './authentication.component';

export const routes: Routes = [
  {
    path: '',
    component: AuthenticationComponent,
    children: [
      { path: 'signup', loadComponent: () => import('./sign-up-profile/sign-up-profile.component').then((m) => m.SignUpProfileComponent) },
      { path: 'login', loadComponent: () => import('./login-page/login-page.component').then((m) => m.LoginPageComponent) },
      { path: 'forgot', loadComponent: () => import('./forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent) },
      {
        path: 'verify-otp/:token',
        loadComponent: () => import('./verify-otp/verify-otp.component').then((m) => m.VerifyOtpComponent),
        data: {
          renderMode: 'default', // Route will be rendered dynamically at runtime
        },
      },
      {
        path: 'verify-otp-email/:token',
        loadComponent: () => import('./verify-otp-email/verify-otp-email.component').then((m) => m.VerifyOtpEmailComponent),
        data: {
          renderMode: 'default', // Route will be rendered dynamically at runtime
        },
      },
      {
        path: 'reset-password/:token',
        loadComponent: () => import('./reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
        data: {
          renderMode: 'default', // Route will be rendered dynamically at runtime
        },
      },
      {
        path: '', // Blank route
        redirectTo: 'signup',
        pathMatch: 'full',
      },
      {
        path: '**', // Wildcard route
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];
